{
  "_generated": "scripts/build_capability_manifest.py from shared/agent/capability_spec.py — do not edit",
  "risks": [
    "R0",
    "R1",
    "R2",
    "R3"
  ],
  "areas": [
    "agents",
    "knowledge",
    "courses",
    "creator",
    "content_in",
    "curriculum",
    "dozent",
    "learners",
    "analytics",
    "lms",
    "moodle",
    "org",
    "account",
    "export",
    "system"
  ],
  "entity_types": [
    "bot",
    "bot_setting",
    "template",
    "bucket",
    "file",
    "website",
    "cloud_connection",
    "course",
    "lesson",
    "course_section",
    "participant",
    "draft",
    "preset",
    "creator_item",
    "exercise",
    "assignment",
    "submission",
    "curriculum_item",
    "study_program",
    "enrollment",
    "learner",
    "conversation",
    "message",
    "notification",
    "faq",
    "guardrail",
    "learning",
    "skill",
    "mcp_connector",
    "placement",
    "lms_registration",
    "moodle_course",
    "ilias_object",
    "user",
    "client",
    "api_key",
    "feature_set",
    "plan",
    "credit",
    "chat_styling",
    "referral_partner",
    "ai_task",
    "contract",
    "invoice"
  ],
  "refresh_resources": [
    "bots",
    "bot_settings",
    "templates",
    "buckets",
    "files",
    "websites",
    "cloud_connections",
    "courses",
    "lessons",
    "participants",
    "drafts",
    "presets",
    "creator_items",
    "exercises",
    "assignments",
    "submissions",
    "curriculum",
    "enrollments",
    "learners",
    "conversations",
    "notifications",
    "faqs",
    "guardrails",
    "learnings",
    "skills",
    "mcp_connectors",
    "placements",
    "lms_registrations",
    "users",
    "organisation",
    "api_keys",
    "feature_sets",
    "credits",
    "plan",
    "chat_styling",
    "contracts",
    "invoices",
    "referrals"
  ],
  "ui_elements": [
    "row",
    "card",
    "settings",
    "field",
    "detail"
  ],
  "actions": {
    "account.academy.progress": {
      "area": "account",
      "risk": "R0",
      "entity_types": [],
      "ui_target": null,
      "refresh": []
    },
    "agent.create": {
      "area": "agents",
      "risk": "R2",
      "entity_types": [
        "bot"
      ],
      "ui_target": null,
      "refresh": [
        "bots"
      ]
    },
    "agent.delete": {
      "area": "agents",
      "risk": "R3",
      "entity_types": [
        "bot"
      ],
      "ui_target": null,
      "refresh": [
        "bots"
      ]
    },
    "agent.duplicate": {
      "area": "agents",
      "risk": "R2",
      "entity_types": [
        "bot"
      ],
      "ui_target": null,
      "refresh": [
        "bots"
      ]
    },
    "agent.faq.create": {
      "area": "agents",
      "risk": "R2",
      "entity_types": [
        "faq"
      ],
      "ui_target": null,
      "refresh": [
        "faqs"
      ]
    },
    "agent.faq.delete": {
      "area": "agents",
      "risk": "R3",
      "entity_types": [
        "faq"
      ],
      "ui_target": null,
      "refresh": [
        "faqs"
      ]
    },
    "agent.faq.list": {
      "area": "agents",
      "risk": "R0",
      "entity_types": [
        "faq"
      ],
      "ui_target": null,
      "refresh": []
    },
    "agent.faq.update": {
      "area": "agents",
      "risk": "R2",
      "entity_types": [
        "faq"
      ],
      "ui_target": null,
      "refresh": [
        "faqs"
      ]
    },
    "agent.get": {
      "area": "agents",
      "risk": "R0",
      "entity_types": [
        "bot"
      ],
      "ui_target": "bot:{id}:card",
      "refresh": []
    },
    "agent.guardrail.create": {
      "area": "agents",
      "risk": "R2",
      "entity_types": [
        "guardrail"
      ],
      "ui_target": null,
      "refresh": [
        "guardrails"
      ]
    },
    "agent.guardrail.list": {
      "area": "agents",
      "risk": "R0",
      "entity_types": [
        "guardrail"
      ],
      "ui_target": null,
      "refresh": []
    },
    "agent.list": {
      "area": "agents",
      "risk": "R0",
      "entity_types": [
        "bot"
      ],
      "ui_target": null,
      "refresh": []
    },
    "agent.models.list": {
      "area": "agents",
      "risk": "R0",
      "entity_types": [],
      "ui_target": null,
      "refresh": []
    },
    "agent.settings.get": {
      "area": "agents",
      "risk": "R0",
      "entity_types": [
        "bot",
        "bot_setting"
      ],
      "ui_target": "bot:{tutor_id}:settings",
      "refresh": []
    },
    "agent.settings.update": {
      "area": "agents",
      "risk": "R2",
      "entity_types": [
        "bot",
        "bot_setting"
      ],
      "ui_target": "bot:{tutor_id}:settings",
      "refresh": [
        "bot_settings"
      ]
    },
    "agent.templates.creatable": {
      "area": "agents",
      "risk": "R0",
      "entity_types": [
        "template"
      ],
      "ui_target": null,
      "refresh": []
    },
    "agent.templates.list": {
      "area": "agents",
      "risk": "R0",
      "entity_types": [
        "template"
      ],
      "ui_target": null,
      "refresh": []
    },
    "agent.update": {
      "area": "agents",
      "risk": "R2",
      "entity_types": [
        "bot"
      ],
      "ui_target": "bot:{id}:card",
      "refresh": [
        "bots"
      ]
    },
    "chat_styling.get": {
      "area": "agents",
      "risk": "R0",
      "entity_types": [
        "chat_styling"
      ],
      "ui_target": null,
      "refresh": []
    },
    "chat_styling.list": {
      "area": "agents",
      "risk": "R0",
      "entity_types": [
        "chat_styling"
      ],
      "ui_target": null,
      "refresh": []
    },
    "chat_styling.update": {
      "area": "agents",
      "risk": "R2",
      "entity_types": [
        "chat_styling"
      ],
      "ui_target": null,
      "refresh": [
        "chat_styling"
      ]
    },
    "course.goals.import": {
      "area": "courses",
      "risk": "R2",
      "entity_types": [
        "course"
      ],
      "ui_target": null,
      "refresh": [
        "courses"
      ]
    },
    "course.goals.link": {
      "area": "courses",
      "risk": "R2",
      "entity_types": [
        "course"
      ],
      "ui_target": null,
      "refresh": [
        "courses"
      ]
    },
    "course.goals.suggest_links": {
      "area": "courses",
      "risk": "R1",
      "entity_types": [
        "course"
      ],
      "ui_target": null,
      "refresh": []
    },
    "course.objectives.create": {
      "area": "courses",
      "risk": "R2",
      "entity_types": [
        "course"
      ],
      "ui_target": null,
      "refresh": [
        "courses"
      ]
    },
    "course.objectives.list": {
      "area": "courses",
      "risk": "R0",
      "entity_types": [
        "course"
      ],
      "ui_target": null,
      "refresh": []
    },
    "course.objectives.update": {
      "area": "courses",
      "risk": "R2",
      "entity_types": [
        "course"
      ],
      "ui_target": null,
      "refresh": [
        "courses"
      ]
    },
    "courses.course.search": {
      "area": "courses",
      "risk": "R0",
      "entity_types": [
        "course"
      ],
      "ui_target": null,
      "refresh": []
    },
    "creator.connection.list": {
      "area": "creator",
      "risk": "R0",
      "entity_types": [],
      "ui_target": null,
      "refresh": []
    },
    "creator.import.get": {
      "area": "creator",
      "risk": "R0",
      "entity_types": [
        "creator_item"
      ],
      "ui_target": null,
      "refresh": []
    },
    "creator.item.comments.list": {
      "area": "creator",
      "risk": "R0",
      "entity_types": [
        "creator_item"
      ],
      "ui_target": null,
      "refresh": []
    },
    "creator.item.create": {
      "area": "creator",
      "risk": "R1",
      "entity_types": [
        "creator_item"
      ],
      "ui_target": null,
      "refresh": []
    },
    "creator.item.get": {
      "area": "creator",
      "risk": "R0",
      "entity_types": [
        "creator_item"
      ],
      "ui_target": null,
      "refresh": []
    },
    "creator.item.history.list": {
      "area": "creator",
      "risk": "R0",
      "entity_types": [
        "creator_item"
      ],
      "ui_target": null,
      "refresh": []
    },
    "creator.item.kb.publish": {
      "area": "creator",
      "risk": "R2",
      "entity_types": [
        "creator_item",
        "bucket"
      ],
      "ui_target": null,
      "refresh": [
        "buckets"
      ]
    },
    "creator.item.kb.withdraw": {
      "area": "creator",
      "risk": "R2",
      "entity_types": [
        "creator_item",
        "bucket"
      ],
      "ui_target": null,
      "refresh": [
        "buckets"
      ]
    },
    "creator.item.list": {
      "area": "creator",
      "risk": "R0",
      "entity_types": [
        "creator_item"
      ],
      "ui_target": null,
      "refresh": []
    },
    "creator.item.moodle.publish": {
      "area": "creator",
      "risk": "R3",
      "entity_types": [
        "creator_item"
      ],
      "ui_target": null,
      "refresh": []
    },
    "creator.item.proposal.get": {
      "area": "creator",
      "risk": "R0",
      "entity_types": [
        "creator_item"
      ],
      "ui_target": null,
      "refresh": []
    },
    "creator.item.proposal.list": {
      "area": "creator",
      "risk": "R0",
      "entity_types": [
        "creator_item"
      ],
      "ui_target": null,
      "refresh": []
    },
    "creator.item.publication.list": {
      "area": "creator",
      "risk": "R0",
      "entity_types": [
        "creator_item"
      ],
      "ui_target": null,
      "refresh": []
    },
    "creator.item.release": {
      "area": "creator",
      "risk": "R1",
      "entity_types": [
        "creator_item"
      ],
      "ui_target": null,
      "refresh": []
    },
    "creator.item.thread.list": {
      "area": "creator",
      "risk": "R0",
      "entity_types": [
        "creator_item"
      ],
      "ui_target": null,
      "refresh": []
    },
    "creator.item.trash.list": {
      "area": "creator",
      "risk": "R0",
      "entity_types": [
        "creator_item"
      ],
      "ui_target": null,
      "refresh": []
    },
    "creator.item.tutor.publish": {
      "area": "creator",
      "risk": "R2",
      "entity_types": [
        "creator_item"
      ],
      "ui_target": null,
      "refresh": [
        "exercises"
      ]
    },
    "creator.item.tutor.withdraw": {
      "area": "creator",
      "risk": "R2",
      "entity_types": [
        "creator_item"
      ],
      "ui_target": null,
      "refresh": [
        "exercises"
      ]
    },
    "creator.item.undelete": {
      "area": "creator",
      "risk": "R1",
      "entity_types": [
        "creator_item"
      ],
      "ui_target": null,
      "refresh": []
    },
    "creator.item.version.create": {
      "area": "creator",
      "risk": "R1",
      "entity_types": [
        "creator_item"
      ],
      "ui_target": null,
      "refresh": []
    },
    "creator.item.version.list": {
      "area": "creator",
      "risk": "R0",
      "entity_types": [
        "creator_item"
      ],
      "ui_target": null,
      "refresh": []
    },
    "creator.job.get": {
      "area": "creator",
      "risk": "R0",
      "entity_types": [
        "creator_item"
      ],
      "ui_target": null,
      "refresh": []
    },
    "creator.kit.list": {
      "area": "creator",
      "risk": "R0",
      "entity_types": [],
      "ui_target": null,
      "refresh": []
    },
    "creator.prices.get": {
      "area": "creator",
      "risk": "R0",
      "entity_types": [],
      "ui_target": null,
      "refresh": []
    },
    "dozent.participant.competency_profile": {
      "area": "dozent",
      "risk": "R0",
      "entity_types": [
        "learner"
      ],
      "ui_target": null,
      "refresh": []
    },
    "dozent.participant.learning_state": {
      "area": "dozent",
      "risk": "R0",
      "entity_types": [
        "learner"
      ],
      "ui_target": null,
      "refresh": []
    },
    "guardrail.create": {
      "area": "agents",
      "risk": "R2",
      "entity_types": [
        "guardrail"
      ],
      "ui_target": null,
      "refresh": [
        "guardrails"
      ]
    },
    "guardrail.delete": {
      "area": "agents",
      "risk": "R3",
      "entity_types": [
        "guardrail"
      ],
      "ui_target": null,
      "refresh": [
        "guardrails"
      ]
    },
    "guardrail.list": {
      "area": "agents",
      "risk": "R0",
      "entity_types": [
        "guardrail"
      ],
      "ui_target": null,
      "refresh": []
    },
    "guardrail.update": {
      "area": "agents",
      "risk": "R2",
      "entity_types": [
        "guardrail"
      ],
      "ui_target": null,
      "refresh": [
        "guardrails"
      ]
    },
    "knowledge.bucket.create": {
      "area": "knowledge",
      "risk": "R2",
      "entity_types": [
        "bucket"
      ],
      "ui_target": null,
      "refresh": [
        "buckets"
      ]
    },
    "knowledge.bucket.delete": {
      "area": "knowledge",
      "risk": "R3",
      "entity_types": [
        "bucket"
      ],
      "ui_target": null,
      "refresh": [
        "buckets"
      ]
    },
    "knowledge.bucket.entries": {
      "area": "knowledge",
      "risk": "R0",
      "entity_types": [
        "bucket",
        "file",
        "website"
      ],
      "ui_target": "bucket:{bucket_id}:row",
      "refresh": []
    },
    "knowledge.bucket.list": {
      "area": "knowledge",
      "risk": "R0",
      "entity_types": [
        "bucket"
      ],
      "ui_target": null,
      "refresh": []
    },
    "knowledge.bucket.update": {
      "area": "knowledge",
      "risk": "R2",
      "entity_types": [
        "bucket"
      ],
      "ui_target": "bucket:{id}:row",
      "refresh": [
        "buckets"
      ]
    },
    "knowledge.file.delete": {
      "area": "knowledge",
      "risk": "R3",
      "entity_types": [
        "file"
      ],
      "ui_target": null,
      "refresh": [
        "files"
      ]
    },
    "lms.progress_source.set": {
      "area": "lms",
      "risk": "R2",
      "entity_types": [
        "lms_registration"
      ],
      "ui_target": null,
      "refresh": [
        "lms_registrations"
      ]
    },
    "lms.progress_sources.discover": {
      "area": "lms",
      "risk": "R1",
      "entity_types": [
        "lms_registration"
      ],
      "ui_target": null,
      "refresh": []
    },
    "lms.registration.list": {
      "area": "lms",
      "risk": "R0",
      "entity_types": [
        "lms_registration"
      ],
      "ui_target": null,
      "refresh": []
    },
    "moodle.activities.save": {
      "area": "moodle",
      "risk": "R3",
      "entity_types": [
        "moodle_course"
      ],
      "ui_target": null,
      "refresh": []
    },
    "moodle.activity.content": {
      "area": "moodle",
      "risk": "R0",
      "entity_types": [
        "moodle_course"
      ],
      "ui_target": null,
      "refresh": []
    },
    "moodle.activity.visibility": {
      "area": "moodle",
      "risk": "R3",
      "entity_types": [
        "moodle_course"
      ],
      "ui_target": null,
      "refresh": []
    },
    "moodle.call": {
      "area": "moodle",
      "risk": "R0",
      "entity_types": [],
      "ui_target": null,
      "refresh": []
    },
    "moodle.call.write": {
      "area": "moodle",
      "risk": "R3",
      "entity_types": [
        "moodle_course"
      ],
      "ui_target": null,
      "refresh": []
    },
    "moodle.course.contents": {
      "area": "moodle",
      "risk": "R0",
      "entity_types": [
        "moodle_course"
      ],
      "ui_target": null,
      "refresh": []
    },
    "moodle.course.grades": {
      "area": "moodle",
      "risk": "R0",
      "entity_types": [
        "moodle_course"
      ],
      "ui_target": null,
      "refresh": []
    },
    "moodle.course.list": {
      "area": "moodle",
      "risk": "R0",
      "entity_types": [
        "moodle_course"
      ],
      "ui_target": null,
      "refresh": []
    },
    "moodle.course.participants": {
      "area": "moodle",
      "risk": "R0",
      "entity_types": [
        "moodle_course"
      ],
      "ui_target": null,
      "refresh": []
    },
    "moodle.functions.find": {
      "area": "moodle",
      "risk": "R0",
      "entity_types": [],
      "ui_target": null,
      "refresh": []
    },
    "moodle.section.update": {
      "area": "moodle",
      "risk": "R3",
      "entity_types": [
        "moodle_course"
      ],
      "ui_target": null,
      "refresh": []
    },
    "org.contract.get": {
      "area": "org",
      "risk": "R0",
      "entity_types": [
        "contract"
      ],
      "ui_target": null,
      "refresh": []
    },
    "org.contract.invoice.pdf": {
      "area": "org",
      "risk": "R0",
      "entity_types": [
        "invoice"
      ],
      "ui_target": null,
      "refresh": []
    },
    "org.contract.invoices.list": {
      "area": "org",
      "risk": "R0",
      "entity_types": [
        "invoice"
      ],
      "ui_target": null,
      "refresh": []
    },
    "org.credit.estimate_basis": {
      "area": "org",
      "risk": "R0",
      "entity_types": [
        "credit"
      ],
      "ui_target": null,
      "refresh": []
    },
    "system.access_logs": {
      "area": "system",
      "risk": "R0",
      "entity_types": [
        "user"
      ],
      "ui_target": null,
      "refresh": []
    },
    "system.ai_routing.control": {
      "area": "system",
      "risk": "R3",
      "entity_types": [
        "ai_task"
      ],
      "ui_target": null,
      "refresh": []
    },
    "system.ai_routing.get": {
      "area": "system",
      "risk": "R0",
      "entity_types": [],
      "ui_target": null,
      "refresh": []
    },
    "system.ai_routing.pin_legacy": {
      "area": "system",
      "risk": "R3",
      "entity_types": [
        "ai_task"
      ],
      "ui_target": null,
      "refresh": []
    },
    "system.ai_routing.reset": {
      "area": "system",
      "risk": "R3",
      "entity_types": [
        "ai_task"
      ],
      "ui_target": null,
      "refresh": []
    },
    "system.ai_routing.switch": {
      "area": "system",
      "risk": "R3",
      "entity_types": [
        "ai_task"
      ],
      "ui_target": null,
      "refresh": []
    },
    "system.client.contract.end": {
      "area": "system",
      "risk": "R3",
      "entity_types": [
        "client",
        "contract"
      ],
      "ui_target": null,
      "refresh": [
        "contracts"
      ]
    },
    "system.client.contract.get": {
      "area": "system",
      "risk": "R0",
      "entity_types": [
        "client",
        "contract"
      ],
      "ui_target": null,
      "refresh": []
    },
    "system.client.contract.upsert": {
      "area": "system",
      "risk": "R2",
      "entity_types": [
        "client",
        "contract"
      ],
      "ui_target": null,
      "refresh": [
        "contracts"
      ]
    },
    "system.client.credits.get": {
      "area": "system",
      "risk": "R0",
      "entity_types": [
        "client",
        "credit"
      ],
      "ui_target": null,
      "refresh": []
    },
    "system.client.credits.grant": {
      "area": "system",
      "risk": "R3",
      "entity_types": [
        "client",
        "credit"
      ],
      "ui_target": null,
      "refresh": []
    },
    "system.client.invoices.create": {
      "area": "system",
      "risk": "R2",
      "entity_types": [
        "client",
        "invoice"
      ],
      "ui_target": null,
      "refresh": [
        "invoices"
      ]
    },
    "system.client.invoices.list": {
      "area": "system",
      "risk": "R0",
      "entity_types": [
        "client",
        "invoice"
      ],
      "ui_target": null,
      "refresh": []
    },
    "system.client.list": {
      "area": "system",
      "risk": "R0",
      "entity_types": [
        "client"
      ],
      "ui_target": null,
      "refresh": []
    },
    "system.client.quota.get": {
      "area": "system",
      "risk": "R0",
      "entity_types": [
        "client"
      ],
      "ui_target": null,
      "refresh": []
    },
    "system.client.quota.update": {
      "area": "system",
      "risk": "R3",
      "entity_types": [
        "client"
      ],
      "ui_target": null,
      "refresh": []
    },
    "system.client.token_usage": {
      "area": "system",
      "risk": "R0",
      "entity_types": [
        "client"
      ],
      "ui_target": null,
      "refresh": []
    },
    "system.client.trial.extend": {
      "area": "system",
      "risk": "R3",
      "entity_types": [
        "client"
      ],
      "ui_target": null,
      "refresh": []
    },
    "system.client.update": {
      "area": "system",
      "risk": "R3",
      "entity_types": [
        "client"
      ],
      "ui_target": null,
      "refresh": []
    },
    "system.contract_templates.create": {
      "area": "system",
      "risk": "R2",
      "entity_types": [
        "contract"
      ],
      "ui_target": null,
      "refresh": [
        "contracts"
      ]
    },
    "system.contract_templates.delete": {
      "area": "system",
      "risk": "R3",
      "entity_types": [
        "contract"
      ],
      "ui_target": null,
      "refresh": [
        "contracts"
      ]
    },
    "system.contract_templates.list": {
      "area": "system",
      "risk": "R0",
      "entity_types": [
        "contract"
      ],
      "ui_target": null,
      "refresh": []
    },
    "system.contract_templates.update": {
      "area": "system",
      "risk": "R2",
      "entity_types": [
        "contract"
      ],
      "ui_target": null,
      "refresh": [
        "contracts"
      ]
    },
    "system.invoice.approve": {
      "area": "system",
      "risk": "R3",
      "entity_types": [
        "invoice"
      ],
      "ui_target": null,
      "refresh": [
        "invoices"
      ]
    },
    "system.invoice.cancel": {
      "area": "system",
      "risk": "R3",
      "entity_types": [
        "invoice"
      ],
      "ui_target": null,
      "refresh": [
        "invoices"
      ]
    },
    "system.invoice.discard": {
      "area": "system",
      "risk": "R2",
      "entity_types": [
        "invoice"
      ],
      "ui_target": null,
      "refresh": [
        "invoices"
      ]
    },
    "system.invoice.pdf": {
      "area": "system",
      "risk": "R0",
      "entity_types": [
        "invoice"
      ],
      "ui_target": null,
      "refresh": []
    },
    "system.margin": {
      "area": "system",
      "risk": "R0",
      "entity_types": [],
      "ui_target": null,
      "refresh": []
    },
    "system.migration.status": {
      "area": "system",
      "risk": "R0",
      "entity_types": [
        "client"
      ],
      "ui_target": null,
      "refresh": []
    },
    "system.referral_statement.hold": {
      "area": "system",
      "risk": "R2",
      "entity_types": [
        "referral_partner"
      ],
      "ui_target": null,
      "refresh": [
        "referrals"
      ]
    },
    "system.token_stats": {
      "area": "system",
      "risk": "R0",
      "entity_types": [],
      "ui_target": null,
      "refresh": []
    },
    "system.user.list": {
      "area": "system",
      "risk": "R0",
      "entity_types": [
        "user"
      ],
      "ui_target": null,
      "refresh": []
    }
  }
}
